import type { GridRenderCellParams } from '@mui/x-data-grid-premium';

import TextEditInputCell from './inputs/TextEditInputCell';
import NumberEditInputCell from './inputs/NumberEditInputCell';
import CurrencyEditInputCell from './inputs/CurrencyEditInputCell';
import SelectEditInputCell from './inputs/SelectEditInputCell';
import ModuleSearchEditInputCell from './inputs/ModuleSearchEditInputCell';
import SearchSelectEditInputCell from './inputs/SearchSelectEditInputCell';
import DateEditInputCell from './inputs/DateEditInputCell';

export type EditInputCellParams<V = any> = GridRenderCellParams<any, V> & {
	className?: string;
	parseValue?: (value: V) => V;
};

export default {
	TextEditInputCell,
	NumberEditInputCell,
	CurrencyEditInputCell,
	SelectEditInputCell,
	ModuleSearchEditInputCell,
	SearchSelectEditInputCell,
	DateEditInputCell
};
